export const USER_PROGRESSED = 'USER_PROGRESSED';

export const userProgressed = payload => dispatch =>
  dispatch({
    type: USER_PROGRESSED,
    payload,
  });
